import { render, staticRenderFns } from "./ConfigListElement.vue?vue&type=template&id=079d0fc6&"
import script from "./ConfigListElement.vue?vue&type=script&lang=js&"
export * from "./ConfigListElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports